import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from '../reducers/dashboard-reducers';
export const selectDashboardState = createFeatureSelector<DashboardState>('dashboard');

export function getMaximisedWidget(dashboardName: string) {
  return createSelector(
    [selectDashboardState],
    (dashboardState: DashboardState) => {
      if (dashboardState && dashboardState.maximisedWidget && dashboardState.maximisedWidget.dashboardName === dashboardName) {
        return dashboardState.maximisedWidget;
      }
      return undefined;
    }
  );
}
